import React from 'react';

import { getProfileHref } from 'common/helpers/routerHelper';

const Edit = (props) => {
  const { clubMembershipId, editText } = props;
  return (
    <a
      className="c7-btn c7-btn--primary"
      href={getProfileHref(`/club-membership/${clubMembershipId}`)}
    >
      {editText}
    </a>
  );
};

export default Edit;
